export default __webpack_public_path__ + "static/media/HeaderBackground.115ba9f6.png";